var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10355 3.39632C3.90829 3.20106 3.59171 3.20106 3.39645 3.39632C3.20118 3.59159 3.20118 3.90817 3.39645 4.10343L9.29298 9.99996L3.39661 15.8963C3.20135 16.0916 3.20135 16.4082 3.39661 16.6034C3.59187 16.7987 3.90845 16.7987 4.10372 16.6034L10.0001 10.7071L15.8964 16.6034C16.0917 16.7987 16.4083 16.7987 16.6036 16.6034C16.7988 16.4082 16.7988 16.0916 16.6036 15.8963L10.7072 9.99996L16.6037 4.10343C16.799 3.90817 16.799 3.59159 16.6037 3.39632C16.4085 3.20106 16.0919 3.20106 15.8966 3.39632L10.0001 9.29285L4.10355 3.39632Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.9ca51130b1ad54bce10cb136bbae92c9.svg";
export { ForwardRef as ReactComponent };